import { news_category_id, category_id } from '@/utils/formConfigCommon';
import pattern from './pattern';

const categoryFormItem = {
  category_logo: {
    type: 'slot',
    label: '板块logo',
    placeholder: '请上传板块logo',
    rules: [
      {
        required: true,
        trigger: 'change',
        message: '请上传板块logo'
      }
    ]
  },
  category_cover: {
    type: 'slot',
    label: '板块封面',
    placeholder: '请上传板块封面',
    rules: [
      {
        required: true,
        trigger: 'change',
        message: '请上传板块封面'
      }
    ]
  },
  category_name: {
    type: 'text',
    label: '板块名称',
    placeholder: '请填写板块名称',
    rules: [
      {
        required: true,
        trigger: 'blur',
        message: '请填写板块名称'
      }
    ]
  },
  category_type: {
    type: 'radio',
    label: '板块类型',
    rules: [
      {
        required: true,
        message: '请选择正确的板块类型',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: 1,
          name: '官方'
        },
        {
          id: 2,
          name: '项目'
        }
      ],
      label: 'name',
      key: 'id'
    }
  },
  is_hot_category: {
    type: 'radio',
    label: '是否热门',
    rules: [
      {
        required: true,
        message: '请选择热门',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      label: 'name',
      key: 'id'
    }
  },
  sort_number: {
    type: 'text',
    label: '板块排序',
    placeholder: '请填写板块排序',
    rules: [
      {
        trigger: 'blur',
        pattern: pattern.number,
        message: '请填写数字'
      }
    ]
  }
};

const postsFormItem = {
  category_id,
  is_topping: {
    type: 'radio',
    label: '置顶',
    rules: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      label: 'name',
      key: 'id'
    }
  },
  is_essence: {
    type: 'radio',
    label: '精华',
    rules: [
      {
        required: true,
        message: '请选择状态',
        trigger: 'change'
      }
    ],
    options: {
      radios: [
        {
          id: true,
          name: '是'
        },
        {
          id: false,
          name: '否'
        }
      ],
      label: 'name',
      key: 'id'
    }
  },
  content: {
    type: 'text',
    label: '帖子内容',
    placeholder: '请填写帖子内容',
    rules: [
      {
        required: true,
        message: '请填写帖子内容',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 6
    }
  },
  attach_url: {
    type: 'slot',
    label: '帖子附件'
  }
};

const newsFormItem = {
  content_url: {
    type: 'slot',
    label: '内容封面',
    rules: [
      {
        required: true,
        message: '请上传内容封面',
        trigger: 'change'
      }
    ]
  },
  content_title: {
    type: 'text',
    label: '标题名称',
    placeholder: '请填写标题名称',
    rules: [
      {
        required: true,
        trigger: 'blur',
        message: '请填写标题名称'
      }
    ]
  },
  news_category_id,
  content: {
    type: 'slot',
    label: '详细内容',
    placeholder: '请填写详细内容',
    rules: [
      {
        required: true,
        message: '请填写详细内容',
        trigger: 'change'
      }
    ]
  }
};
const appointment_config = {
  time_config: {
    type: 'date',
    label: '活动时间',
    placeholder: '请选择活动时间',
    rules: [
      {
        required: true,
        message: '请选择活动时间',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'daterange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'value-format': 'yyyy-MM-dd',
      'picker-options': {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    }
  },
  reserve_desc: {
    type: 'text',
    label: '入园须知',
    placeholder: '请填写入园须知',
    rules: [
      {
        required: true,
        message: '请填写入园须知',
        trigger: 'blur'
      }
    ],
    options: {
      type: 'textarea',
      rows: 6
    }
  },
  reserve_limit: {
    type: 'text',
    label: '限制人数',
    placeholder: '请填写限制人数',
    rules: [
      {
        required: true,
        pattern: pattern.number,
        message: '请正确填写限制人数',
        trigger: 'blur'
      }
    ]
  }
};

export { categoryFormItem, postsFormItem, newsFormItem, appointment_config };
